const getStarIcon = (star, current) => {
    if (current >= star) return "/assets/icons/stars/star-full.png";
    if (current >= star - 0.5) return "/assets/icons/stars/star-half.png";
    return "/assets/icons/stars/star-empty.png";
};

export default function Review({ review }) {
    const { user, rating, review: text } = review;

    return (
        <li className="reviewItem">
            <div className="reviewHeader">
                {/* <span className="reviewUser">
                    {user?.username ?? "Unknown user"}
                </span> */}
                <span className="reviewUser">
                    Watched
                </span>

                {rating > 0 && (
                    <span className="reviewRating" aria-label={`${rating} out of 5`}>
                        {[1, 2, 3, 4, 5].map((star) => (
                            <img
                                key={star}
                                className="reviewStar"
                                src={getStarIcon(star, rating)}
                                alt=""
                            />
                        ))}
                    </span>
                )}
            </div>

            {text?.trim() && <p className="reviewText">{text}</p>}
        </li>
    );
}
